import { render, staticRenderFns } from "./product-research.vue?vue&type=template&id=c0c40c56&scoped=true&"
import script from "./product-research.vue?vue&type=script&lang=js&"
export * from "./product-research.vue?vue&type=script&lang=js&"
import style0 from "./product-research.vue?vue&type=style&index=0&id=c0c40c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c40c56",
  null
  
)

export default component.exports